import {AssignTermPopupConfirmationModal} from "view/apps/Organiser/pages/Show/Glossary/components/AssignTermPopupToBuildTypeModal/utils/types";
import React, {Fragment} from "react";
import {grey} from "@material-ui/core/colors";
import {Typography} from "@material-ui/core";

export const ASSIGN_TERM_POPUP_CONFIRMATION_MODAL_DESCRIPTION = {
  [AssignTermPopupConfirmationModal.Unassign]: (
    conflictingTermByBuilder: Record<string, string>
  ) => (
    <Typography variant="h4" style={{color: grey[800]}}>
      The following Build Types already have a Pop-up assigned. Please select a
      different Build Type
      <br />
      <br />
      {Object.entries(conflictingTermByBuilder).map(([builder, term], idx) => (
        <Fragment key={idx}>
          [{builder}]: {term}
          <br />
        </Fragment>
      ))}
      <br />
      Are you sure you want to unassign the currently selected Pop-up?
    </Typography>
  ),
  [AssignTermPopupConfirmationModal.AssignBuilders]: (builders: string[]) => (
    <>
      The following build types will be added to this section:
      <br /> <br />
      {builders.map((builder) => (
        <Fragment key={builder}>
          {builder}
          <br />
        </Fragment>
      ))}
      <br />
      Are you sure you want to proceed?
    </>
  ),
} as const;
